module.exports = __webpack_public_path__ + "img/culture-bg.51f65316.jpg";